// extracted by mini-css-extract-plugin
export default {"tabControlsContainer":"styles_tabControlsContainer__X1syJ","tab":"styles_tab__2Nox6"};